import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const Message: AppRouteRecordRaw = {
  path: '/message',
  name: 'message',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '消息中心',
    requiresAuth: true,
    icon: 'icon-bookmark',
    order: 6,
  },
  children: [
    {
      path: 'messageList',
      name: 'MessageList',
      component: () => import('@/views/messageNotice/index.vue'),
      meta: {
        title: '消息列表',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
  ],
};

export default Message;
